import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { callApi } from "../../../lib/apiCaller"; // adjust path if needed

// ✅ Create new booking (POST)
export const createNewBooking = createAsyncThunk(
  "booking/createNewBooking",
  async (bookingData, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "CREATE_NEW_BOOKING",
        body: bookingData,
        auth: true,
        method: "POST",
      });
      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to create booking",
      );
    }
  },
);

// ✅ Fetch customer booking history (GET)
export const fetchBookingHistory = createAsyncThunk(
  "booking/fetchBookingHistory",
  async (email, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "FETCH_CUSTOMER_BOOKING_HISTORY",
        method: "GET",

        auth: true,
      });
      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch booking history",
      );
    }
  },
  {
    // Prevent duplicate requests if already loading or history exists
    condition: (_, { getState }) => {
      const state = getState().booking;
      if (state.loading) return false;
      if (state.history && state.history.length > 0) return false;
      return true;
    },
  },
);

// ✅ Fetch current booking (GET, can pass params if needed)
export const fetchCurrentBooking = createAsyncThunk(
  "booking/fetchCurrentBooking",
  async (id, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "FETCH_CURRENT_BOOKING",
        method: "GET",
        params: { bookingId: id },
        auth: true, // pass ?id=...
      });
      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch current booking",
      );
    }
  },
);

export const updateBooking = createAsyncThunk(
  "booking/updateBooking",
  async (payload, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "UPDATE_BOOKING",
        method: "PUT",
        body: payload,

        auth: true,
      });
      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch current booking",
      );
    }
  },
);

//cancel booking (GET, can pass params if needed)
export const cancelBooking = createAsyncThunk(
  "booking/cancelBooking",
  async (id, ThunkAPI) => {
    try {
      const res = await callApi({
        key: "CANCEL_BOOKING",
        method: "DELETE",
        params: { bookingId: id },

        auth: true, // pass ?id=...
      });
      return res?.data;
    } catch (error) {
      return ThunkAPI.rejectWithValue(
        error?.message || "Failed to fetch current booking",
      );
    }
  },
);

const bookingSlice = createSlice({
  name: "booking",
  initialState: {
    loading: false,
    error: null,
    history: null,
    current: null,
    newBooking: null,
  },
  reducers: {
    resetBookingState(state) {
      state.loading = false;
      state.error = null;
      state.history = null;
      state.current = null;
      state.newBooking = null;
    },
  },
  extraReducers: (builder) => {
    builder
      // createNewBooking
      .addCase(createNewBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(createNewBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.newBooking = action.payload;
      })
      .addCase(createNewBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchBookingHistory
      .addCase(fetchBookingHistory.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchBookingHistory.fulfilled, (state, action) => {
        state.loading = false;
        state.history = action.payload.value;
      })
      .addCase(fetchBookingHistory.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      // fetchCurrentBooking
      .addCase(fetchCurrentBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchCurrentBooking.fulfilled, (state, action) => {
        state.loading = false;

        state.current = action.payload.value;
      })
      .addCase(fetchCurrentBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })
      .addCase(cancelBooking.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(cancelBooking.fulfilled, (state, action) => {
        state.loading = false;
        state.current = action.payload;
      })
      .addCase(cancelBooking.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const { resetBookingState } = bookingSlice.actions;
export default bookingSlice.reducer;
